// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip__tooltip___773ZT","content":"Tooltip__content___ELYC6","isInline":"Tooltip__isInline___00FCc"};